import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { ThemeProvider } from "@mui/material/styles";
import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
import Button from "@mui/material/Button";
import Link from "@mui/material/Link";
import InputBase from "@mui/material/InputBase";
import { styled } from "@mui/material/styles";
import React, { useEffect, useRef, useState } from "react";
import google from "./../../assets/images/socialMedia/google.svg";
import apple from "./../../assets/images/socialMedia/apple.svg";
import facebook from "./../../assets/images/socialMedia/facebook.svg";
import CircularProgress from '@mui/material/CircularProgress';
import { useNavigate, useLocation, Link as RouterLink } from 'react-router-dom';
import InputAdornment from '@mui/material/InputAdornment';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import Visibility from '@mui/icons-material/Visibility';
import IconButton from '@mui/material/IconButton';
import { validateLoginForm, validateFacebookEmail, } from "../../Business/AuthenticationBusiness";
import { loginFirebaseAccountWithFacebook } from "../../Business/AuthenticationBusiness";
import { loginFirebaseAccountWithGoogle } from "../../Business/AuthenticationBusiness";
import { loginFirebaseWithPassword } from "../../Business/AuthenticationBusiness";
import { loginFirebaseAccountWithApple } from "../../Business/AuthenticationBusiness";
import { getErrorMessage } from "../../Business/AuthenticationBusiness";
import { getUserByAuthId, getUserByEmail } from "../../Repository/Api";
import { getFirebaseAuthModule } from "../../Repository/Authentication/Firebase";
import { getAuth, signInWithCustomToken } from "firebase/auth";
import { GoogleAuthProvider, FacebookAuthProvider, OAuthProvider } from "firebase/auth";
import { CreatePasswordBasedAccount } from "../../Repository/Authentication/Firebase";
import { getFirebaseAuthJWTToken } from "../../Repository/Authentication/Firebase";
import { createUser, verifyEmailFirebase } from "./../../Repository/Api";
import { signOut } from '../../Business/AuthenticationBusiness';
import { createFirebaseAccountWithGoogle } from "../../Business/AuthenticationBusiness";
import { updateEmailId } from "../../Repository/Authentication/Firebase"
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { useAuthUser } from "../../Context/AuthUserContext";
import {
  clearPendingQrReturn,
  readPendingQrReturn,
  savePendingQrReturn,
} from "../../Business/CamiCodeScanBusiness";


const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function Login(props) {


  const [openAlert, setOpenAlert] = useState(false);

  const handleClickAlert = () => {
    setOpenAlert(true);
  };


  const handleCloseAlert = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenAlert(false);
  }


  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("md"));
  const navigate = useNavigate();
  const _location = useLocation();
  const { authReady, profile, profileLoading, isLoggedIn } = useAuthUser();
  const standaloneLogin = typeof props['type'] === 'undefined';
  const submitLockRef = useRef(false);
  const redirectedRef = useRef(false);
  const consumedLoginStateKeyRef = useRef(null);
  const [oneShotNoVideoMessage, setOneShotNoVideoMessage] = useState("");
  const [oneShotRegisterSuccess, setOneShotRegisterSuccess] = useState(false);

  // Capture QR redirect state once, then clear sticky location.state so the
  // message does not reappear on later Login visits (logout, refresh, remount).
  useEffect(() => {
    if (!standaloneLogin) {
      return;
    }
    const state = _location.state;
    if (!state || consumedLoginStateKeyRef.current === _location.key) {
      return;
    }

    const hasFrom = Boolean(state.from);
    const hasMessage = Boolean(state.noVideoMessage);
    const hasRegister = Boolean(state.registerSuccess);
    if (!hasFrom && !hasMessage && !hasRegister) {
      return;
    }

    consumedLoginStateKeyRef.current = _location.key;

    if (hasFrom) {
      savePendingQrReturn(state.from);
    }
    if (hasMessage) {
      setOneShotNoVideoMessage(String(state.noVideoMessage));
    }
    if (hasRegister) {
      setOneShotRegisterSuccess(true);
    }

    navigate(
      {
        pathname: _location.pathname,
        search: _location.search,
        hash: _location.hash,
      },
      { replace: true, state: null }
    );
  }, [
    standaloneLogin,
    _location.key,
    _location.state,
    _location.pathname,
    _location.search,
    _location.hash,
    navigate,
  ]);

  const resolveRedirectTarget = () => {
    const fromLocation = readPendingQrReturn();
    if (!fromLocation) {
      return { pathname: "/" };
    }
    return {
      pathname: fromLocation.pathname || "/",
      search: fromLocation.search || "",
      hash: fromLocation.hash || "",
    };
  };

  const goAfterLogin = () => {
    if (redirectedRef.current) {
      return;
    }
    redirectedRef.current = true;
    const target = resolveRedirectTarget();
    setOneShotNoVideoMessage("");
    clearPendingQrReturn();
    navigate(target, { replace: true });
  };

  useEffect(() => {
    if (!isLoggedIn) {
      redirectedRef.current = false;
    }
  }, [isLoggedIn]);

  const xlPage = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: 80,
    width: "400px",
    marginLeft: "auto",
    marginRight: "auto",
    borderRadius: 20,
    marginBottom: 60,
    border: "1px solid #E5E7EB",
    boxShadow: "0 12px 32px rgba(24, 32, 104, 0.1), 0 2px 6px rgba(24, 32, 104, 0.04)",
    backgroundColor: "#FFFFFF",
    overflow: "hidden",
  };
  const smPage = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: 2,
    width: "100%",
    backgroundColor: "#FFFFFF",
  };

  const errorText = {
    color: "#B01840",
    fontSize: 13,
    marginTop: 1,
    marginBottom: 1,
  };

  const socialLogo = {
    padding: 16,
    height: 64,

  }
  const socialLogoContainer = {
    my: 2,
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
  };

  const mainColor = theme.palette.primary.main;
  const whiteColor = "#000";
  const inputFieldColor = "#EEF0F3";

  const ColorButton = styled(Button)(({ theme }) => ({
    color: "#FFFFFF",
    backgroundColor: theme.palette.secondary.main,
    borderRadius: 999,
    fontWeight: 600,
    textTransform: "none",
    boxShadow: "0 4px 14px rgba(176, 24, 64, 0.28)",
    transition: "background-color 0.2s ease, box-shadow 0.2s ease, transform 0.15s ease",
    "&:hover": {
      backgroundColor: theme.palette.secondary.dark,
      boxShadow: "0 6px 18px rgba(176, 24, 64, 0.35)",
      transform: "translateY(-1px)",
    },
  }));

  const initialValues = {
    username: "",
    email: "",
    password: "",
    showPassword: "false",
  };
  const [formValues, setFormValues] = useState(initialValues);
  const [formErrors, setFormErrors] = useState({});
  const [apiError, setApiError] = useState("");
  const [isSubmit, setIsSubmit] = useState(false);
  const [isEmailSubmit, setEmailSubmit] = useState(false);
  const [showUi, setShowUi] = useState(false);
  const [emailOfUser, setEmailOfUser] = useState("");
  const [authId, setAuthId] = useState("");
  const [signInMethod, setSignInMethod] = useState("");
  const [firstName, setFirstName] = useState("")
  const [email, setEmail] = useState("")


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const handleClickShowPassword = () => {
    setFormValues({
      ...formValues,
      showPassword: !formValues.showPassword,
    });
  };

  useEffect(() => {
    if (!authReady || !standaloneLogin) {
      return;
    }

    if (!isLoggedIn) {
      return;
    }

    if (profileLoading && !profile) {
      return;
    }

    goAfterLogin();
  }, [authReady, isLoggedIn, profile, profileLoading, standaloneLogin]);

  const completeLogin = async () => {
    if (!standaloneLogin) {
      return;
    }
    goAfterLogin();
  };

  const beginSubmit = () => {
    if (submitLockRef.current) {
      return false;
    }
    submitLockRef.current = true;
    setIsSubmit(true);
    return true;
  };

  const endSubmit = () => {
    submitLockRef.current = false;
    setIsSubmit(false);
  };


  const handleSubmit = (e) => {
    e.preventDefault();
    if (submitLockRef.current) {
      return;
    }
    const submittedFormValues = {
      ...formValues,
      email: String(new FormData(e.currentTarget).get("email") ?? formValues.email ?? "").trim(),
      password: String(new FormData(e.currentTarget).get("password") ?? formValues.password ?? ""),
    };
    setFormValues((prev) => ({
      ...prev,
      email: submittedFormValues.email,
      password: submittedFormValues.password,
    }));
    const validation = validateLoginForm(submittedFormValues);
    setFormErrors(validation.errorList);
    if (validation.status === true) {
      if (!beginSubmit()) {
        return;
      }
      loginFirebaseWithPassword(submittedFormValues)
        .then(async (response) => {
          const authId = response?.user?.uid;
          const userRecord = authId ? await getUserByAuthId(authId) : null;
          endSubmit();
          setApiError("Login Successful");
          setFormValues(initialValues);
          console.log(props['type'], ":Props type")
          e.stopPropagation();
          await completeLogin();
        })
     
        .catch((error) => {
          endSubmit();
          setApiError(getErrorMessage(error));
        });
    }
  };


  const handleGoogleLogin = (e) => {
    if (!beginSubmit()) {
      return;
    }
    loginFirebaseAccountWithGoogle()
      .then((response) => {
        console.log(response, "handleGoogleLogin Response")
        const credential = GoogleAuthProvider.credentialFromResult(response);
        const token = credential.accessToken;
        const user = response.user;
        const auth = getFirebaseAuthModule();
        let email = response.user.providerData[0].email;
        let authId = response.user.uid
        console.log(authId, 'auth');
        getUserByAuthId(authId).then((response) => {
          console.log(response, "email exist or not")
          console.log(response.authId, 'authid create');
          endSubmit();
          setApiError("Login Successful.");
          return completeLogin(response);
        }).catch((error) => {
          console.log(error, "No account in DB. So creating User")
          return new Promise((resolve, reject) => {
            getFirebaseAuthJWTToken(auth)
              .then((IDTOKEN) => {
                console.log(credential, token, user);
                localStorage.setItem("logintype", "google");
                localStorage.setItem("GOUC", user);
                localStorage.setItem("JWTTOKEN", IDTOKEN);
                const createUserData = {
                  authId: user.uid,
                  signInMethod: credential.signInMethod,
                  email: user.providerData[0].email,
                  firstName: user.displayName,
                  lastName: "",
                  userTypeId: 1,
                  userRoleId: 0,
                  createdBy: 0,
                  recordStatus: true,
                  registerStatus: true,

                };
                createUser(createUserData)
                  .then(async (response) => {
                    console.log(response, "respGoogle")
                    resolve(response);
                    endSubmit();
                    console.log("account created2")
                    await completeLogin(response);
                  })
                  .catch((error1) => {
                    console.log(error1, "error1Google")
                    reject(error1);
                  });
                console.log("account created")
              })
              .catch((error3) => {
                console.log(error3, "error3Google")
                console.log("account created1")
                reject(error3);
              });
          })
        })
        }).catch((error) => {
          endSubmit();
          setApiError(getErrorMessage(error));
        });
  }

  const handleFacebookLogin = (e) => {
    if (!beginSubmit()) {
      return;
    }
    loginFirebaseAccountWithFacebook()
      .then((response) => {
        console.log(response, "handleFacebookLogin Response")
        const credential = FacebookAuthProvider.credentialFromResult(response);
        const token = credential.accessToken;
        const user = response.user;
        const auth = getFirebaseAuthModule();
        let email = response.user.providerData[0].email;
        let authId = response.user.uid
        getUserByAuthId(authId).then((response) => {
          console.log(response, "email exist or not")
          endSubmit();
          setApiError("Login Successful.");
          return completeLogin(response);
        }).catch((error) => {
          console.log(error, "No account in DB. So creating User")
          return new Promise((resolve, reject) => {
            getFirebaseAuthJWTToken(auth)
              .then((IDTOKEN) => {
                // verifyEmailFirebase(user.uid).then((res) => {
                //   console.log(res);
                // })
                console.log(credential, token, user);
                localStorage.setItem("logintype", "facebook");
                localStorage.setItem("FBUC", user);
                localStorage.setItem("JWTTOKEN", IDTOKEN);
                setAuthId(user.uid);
                setSignInMethod(credential.signInMethod);
                setEmailOfUser(user.email)
                setFirstName(user.displayName);
                if (user.email !== null) {
                  setShowUi(false)
                  console.log('inside email check')
                  const createUserData = {
                    authId: user.uid,
                    signInMethod: credential.signInMethod,
                    email: user.providerData[0].email,
                    firstName: user.displayName,
                    lastName: "",
                    userTypeId: 1,
                    userRoleId: 0,
                    createdBy: 0,
                    recordStatus: true,
                    registerStatus: true,

                  };
                  createUser(createUserData)
                    .then(async (response) => {
                      console.log(response, "respFaceBook")
                      resolve(response);
                      endSubmit()
                      console.log("account created2 FaceBook")
                      await completeLogin(response);
                    })
                    .catch((error1) => {
                      console.log(error1, "error1FaceBook")
                      reject(error1);
                    });
                } else {
                  console.log('no email in this facebook account')
                  setShowUi(true)
                  console.log("update");

                }
              })
              .catch((error3) => {
                console.log(error3, "error3FaceBook")
                console.log("account created1 FaceBook")
                reject(error3);
              });
          })
        })
        }).catch((error) => {
          endSubmit();
          setApiError(getErrorMessage(error));
        })
  }


  const handleSubmitEmail = (e) => {
    if (!beginSubmit()) {
      return;
    }
    if (emailOfUser) {
      const createUserData = {
        "authId": authId,
        "signInMethod": signInMethod,
        "email": emailOfUser,
        "firstName": firstName,
        "lastName": "",
        "userTypeId": 1,
        "userRoleId": 0,
        "createdBy": 0,
        "recordStatus": true,
        "registerStatus": true,
      };
      const validation = validateFacebookEmail(createUserData);
      if (validation.status === true) {
        console.log('inside createuser')
        createUser(createUserData)
          .then(async (response) => {
            console.log(' created user')
            updateEmailId(emailOfUser);
            console.log(response, 'created User in DB');
            endSubmit()
            // setEmailSubmit(true);
            setApiError("Login Successful");
            console.log('logged In')
            await completeLogin(response);
          })
          .catch((error) => {
            // setEmailSubmit(false);
            endSubmit();
            setApiError(getErrorMessage(error));
            console.log(error, 'err');
          });

      } else {
        endSubmit();
      }

    } else {
      endSubmit();
    }

  }




  const handleAppleLogin = (e) => {
    if (!beginSubmit()) {
      return;
    }
    loginFirebaseAccountWithApple()
      .then((response) => {
        console.log(response, "handleAppleLogin Response")
        const credential = OAuthProvider.credentialFromResult(response);
        const token = credential.accessToken;
        const user = response.user;
        const auth = getFirebaseAuthModule();
        let email = response.user.providerData[0].email;
        let authId = response.user.uid
        getUserByAuthId(authId).then((response) => {
          localStorage.setItem('email', email);
          console.log(response, "email exist or not")
          endSubmit();
          setApiError("Login Successful.");
          return completeLogin(response);
        }).catch((error) => {
          console.log(error, "No account in DB. So creating User")
          return new Promise((resolve, reject) => {
            getFirebaseAuthJWTToken(auth)
              .then((IDTOKEN) => {
                console.log(credential, token, user);
                localStorage.setItem("logintype", "apple");
                localStorage.setItem("APUC", user);
                localStorage.setItem("JWTTOKEN", IDTOKEN);
                const createUserData = {
                  authId: user.uid,
                  signInMethod: credential.signInMethod,
                  email: user.providerData[0].email,
                  firstName: user.providerData[0].email.substring(0, user.providerData[0].email.lastIndexOf("@")),
                  lastName: "",
                  userTypeId: 1,
                  userRoleId: 0,
                  createdBy: 0,
                  recordStatus: true,
                  registerStatus: true,
                };
                createUser(createUserData)
                  .then(async (response) => {
                    console.log(response, "respApple")
                    endSubmit();
                    resolve(response);
                    console.log("account created2 Apple")
                    await completeLogin(response);
                  })
                  .catch((error1) => {
                    console.log(error1, "error1Apple")
                    reject(error1);
                  });
                console.log("account created")
              })
              .catch((error3) => {
                console.log(error3, "ErrorLoginApple")
                if (error3.code === "auth/user-cancelled") {
                  reject("User cancelled Login");
                  setApiError("User cancelled Login");
                }
                if (error3.code === "auth/cancelled-popup-request") {
                  console.log(error3.message);
                  reject("User cancelled popup request")
                  setApiError("User cancelled popup request");
                }
                if (error3.code === "auth/popup-closed-by-user") {
                  console.log(error3.message);
                  reject("Popup Closed by User")
                  setApiError("Popup Closed by User");
                }

              });
          })
        })
      }).catch((error) => {
        endSubmit();
        setApiError(getErrorMessage(error));
      })
  }

  /**HTML Section */
  const renderLoginForm = () => {
    if (matches) {
      return (
        <Box elevation={0} style={smPage}>
          <ThemeProvider theme={theme}>
            <Container
              component="main"
              maxWidth="xs"
              sx={{
                width: '100%',
                marginTop: 8,
                marginBottom: 8,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <CssBaseline />
              <Box  >

                {showUi == false && renderLoginFormContent()}
                {showUi == true && renderEmailFromContent()}
              </Box>
            </Container>
          </ThemeProvider>
        </Box>
      );
    } else {
      return (
        <Paper elevation={2} style={xlPage}>
          <ThemeProvider theme={theme}>
            <Container
              component="main"
              maxWidth="xs"
              sx={{
                width: '100%',
                marginTop: 8,
                marginBottom: 8,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <CssBaseline />
              <Box>

                {showUi == false && renderLoginFormContent()}
                {showUi == true && renderEmailFromContent()}

              </Box>

            </Container>
          </ThemeProvider>
        </Paper>
      );
    }
  };


  const renderEmailFromContent = () => {
    if (isSubmit === true) {
      return (
        <Box sx={{ textAlign: "center" }} >
          <CircularProgress sx={{
            marginTop: 3,
            marginBottom: 3,
            marginLeft: "auto",
            marginRight: "auto"
          }} />
        </Box>
      );
    } else {
      return (<>{renderEmailFromUser()}</>);
    }
  }


  const renderEmailFromUser = () => {
    // if (showUi == true) {
    return (
      <>
        <Typography
          variant="h5"
          sx={{
            textAlign: "left",
            alignItems: "flex-start",
            color: theme.palette.primary.main, mb: 2
          }}
        >
          Please enter your email ID to Create account!
        </Typography>
        <Box
          component="form"
          noValidate
          sx={{
            display: "flex",
            flexDirection: "column",
            marginLeft: "auto",
            marginRight: "auto",
            mb: 2,
          }}
        >
          <InputBase
            size="small"
            id="user email"
            placeholder="Email"
            name="user email"
            autoComplete="email"
            autoFocus
            disabled={isSubmit}
            value={emailOfUser}
            onChange={(e) => { setEmailOfUser(e.target.value) }}
            sx={{
              mt: 2,
              mb: 2,
              backgroundColor: inputFieldColor,
              paddingBlock: 1.25,
              paddingInlineStart: 1.5,
              paddingInlineEnd: 1.5,
              borderRadius: "12px",
              border: "1px solid #E5E7EB",
              transition: "border-color 0.2s ease, box-shadow 0.2s ease",
              "&.Mui-focused": {
                borderColor: "#B01840",
                boxShadow: "0 0 0 3px rgba(176, 24, 64, 0.12)",
              },
            }}
          />
          <ColorButton
            onClick={handleSubmitEmail}
            disabled={isSubmit}
            sx={{
              borderRadius: 30,
              width: 140
            }}
            variant="contained"
          >
            CONTINUE
          </ColorButton>
        </Box>
      </>
    )

    // }
  }


  const renderLoginFormContent = () => {
    if (isSubmit === true) {
      return (
        <Box>
          <Box sx={{ textAlign: "center" }} >
            <CircularProgress sx={{
              marginTop: 3,
              marginBottom: 3,
              marginLeft: "auto",
              marginRight: "auto"
            }} />
          </Box>
        </Box>
      );
    } else {
      return (<>{loginFormContent()}</>);
    }
  }

  const loginFormContent = () => {
    return (
      <>
        {oneShotNoVideoMessage ? (
          <Alert
            severity="info"
            onClose={() => setOneShotNoVideoMessage("")}
            sx={{ mb: 2, width: "100%" }}
          >
            {oneShotNoVideoMessage}
          </Alert>
        ) : null}
        {oneShotRegisterSuccess ? (
          <Alert
            severity="success"
            onClose={() => setOneShotRegisterSuccess(false)}
            sx={{ mb: 2, width: "100%" }}
          >
            Account created successfully! Please log in with your credentials.
          </Alert>
        ) : null}
        <Typography
        variant="h5"
        sx={{
          color: theme.palette.primary.main,
          fontWeight: 700,
          letterSpacing: "-0.02em",
          mb: 0.5,
        }}
      >
        Log In
      </Typography>
      <Typography
        sx={{
          color: theme.palette.text.secondary,
          fontSize: "0.925rem",
          mb: 1,
        }}
      >
        Welcome back to Bezohminds
      </Typography>
        <Box
          component="form"
          onSubmit={handleSubmit}
          noValidate
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          <InputBase
            size="small"
            id="email"
            placeholder="Email"
            name="email"
            autoFocus = {true}
            autoComplete="email"
            disabled={isSubmit}
            value={formValues.email}
            onChange={handleChange}
            sx={{
              width: '100%',
              mt: 2,
              mb: 2,
              backgroundColor: inputFieldColor,
              paddingBlock: 1.25,
              paddingInlineStart: 1.5,
              paddingInlineEnd: 1.5,
              borderRadius: "12px",
              border: "1px solid #E5E7EB",
            }}
          />
          {formErrors.email && (<p style={errorText}>{formErrors.email}</p>)}
          {formErrors.emailValid && (<p style={errorText}>{formErrors.emailValid}</p>)}
          <InputBase
            size="small"
            name="password"
            placeholder="Password"
            type={formValues.showPassword ? 'password' : 'text'}
            id="password"
            autoComplete="current-password"
            disabled={isSubmit}
            value={formValues.password}
            onChange={handleChange}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  disabled={isSubmit}
                  onMouseUp={handleClickShowPassword}
                  onMouseDown={handleClickShowPassword}
                  onTouchStart={handleClickShowPassword}
                  onTouchEnd={handleClickShowPassword}
                  onTouchCancel={handleClickShowPassword}
                  edge="end"
                >
                  {formValues.showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
            sx={{
              width: '100%',
              backgroundColor: inputFieldColor,
              paddingBlock: 1.25,
              paddingInlineStart: 1.5,
              paddingInlineEnd: 1.5,
              borderRadius: "12px",
              border: "1px solid #E5E7EB",
              mb: 1,
            }}
          />
          {formErrors.password && <p style={errorText}>{formErrors.password}</p>}
          {formErrors.passwordValid && <p style={errorText}>{formErrors.passwordValid}</p>}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              marginTop: 3,
              marginBottom: 2,
              marginLeft: "auto",
              marginRight: "auto",
            }}
          >
            <ColorButton
              type="submit"
              disabled={isSubmit}
              sx={{
                borderRadius: 30,
                width: 140,
              }}
              variant="contained"
            >
              LOGIN
            </ColorButton>
            <Grid container sx={{ ...socialLogoContainer, opacity: isSubmit ? 0.6 : 1, pointerEvents: isSubmit ? "none" : "auto" }}>
              {/* <Link href="#"> <img src={google} style={socialLogo} onClick={handleGoogleLogin}></img> </Link>
              <Link href="#"> <img src={apple} style={socialLogo} onClick={handleAppleLogin}></img> </Link>
              <Link href="#"> <img src={facebook} style={socialLogo} onClick={handleFacebookLogin}></img> </Link> */}
            </Grid>
            {
              (typeof props['type'] == 'undefined' && props['type'] != 'imported') &&
              <>
                <Grid
                  container
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "center",
                  }} >
                  <Grid
                    item
                    sx={{
                      color: "black",
                    }} >
                    <Link
                      component={RouterLink}
                      to="/register"
                      state={{ from: resolveRedirectTarget() }}
                      variant="body2"
                      color="inherit"
                      sx={{ color: theme.palette.primary.main }}>
                      {"Sign Up Today"}
                    </Link>
                  </Grid>
                </Grid>
                <Grid
                  container
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "center",
                  }} >
                  <Grid
                    item
                    sx={{
                      color: "black",
                      mt: 1
                    }} >
                    <Link
                      component={RouterLink}
                      to="/forgot-password"
                      variant="body2"
                      color="inherit"
                      sx={{ color: theme.palette.primary.main, }} >
                      Forgot Password?
                    </Link>
                  </Grid>
                </Grid>
              </>
            }

            {apiError && (<p style={errorText}>{apiError}</p>)}
          </div>
        </Box>

        {openAlert && (<Stack spacing={2} sx={{ width: '100%' }}>

          <Snackbar open={openAlert} autoHideDuration={6000} onClose={handleCloseAlert}>
            <Alert onClose={handleCloseAlert} severity="error" sx={{ width: '100%' }}>
              User account doesn't exist. Please signUp.
            </Alert>
          </Snackbar>

        </Stack>)}

      </>
    );
  };

  return <>{renderLoginForm()}</>;
}
export default Login;
